<template>
<v-dialog v-model="show" max-width="800">
  <template v-slot:activator="{on}">
    <v-badge :content="(sample.sample_notes.length + sample.sample_flags.length).toString()" overlap>
      <v-btn v-on="on" tile outlined small>notes/flags</v-btn>
    </v-badge>
  </template>
  <v-card>
    <CardTitle :title="`Notes/Flags - ${sample.id}`">
      <template v-slot:actions>
        <v-btn @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </CardTitle>
    <v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-center title"> Flags </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><v-autocomplete v-model="applyFlags" label="Add Flags" multiple :items="flagTypes" item-text="name" item-value="uuid" :loading="savingFlags" :disabled="savingFlags">
              <template v-slot:append-outer>
                <v-btn @click="submitFlags" class="success" icon :loading="savingFlags" :disabled="savingFlags"><v-icon>mdi-arrow-right</v-icon></v-btn>
              </template>
            </v-autocomplete></td>
          </tr>
          <tr v-for="flag in sample.sample_flags" :key="flag.uuid">
            <td><v-chip :color="flag.flag_type.color" class="white--text">{{flag.flag_type.name}}</v-chip></td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-divider></v-divider>
      <v-form ref="form">
        <v-simple-table>
          <thead>
          <tr><th colspan="3" class="text-center title">Notes</th></tr>
          <tr>
            <th>Type</th>
            <th>Note</th>
            <th>Edit</th>
          </tr>
          </thead>
          <tbody>
          <!--          <v-form refs="form">-->
          <tr>
            <td>
              <v-autocomplete
                  v-model="form.sample_note_type_uuid"
                  label="Note Type"
                  :items="$store.$db().model('sampleNoteTypes').all()"
                  item-text="name"
                  item-value="uuid"
                  :rules="[v => !!v || 'This field is required.']"
                  solo-inverted
                  dense
                  mandatory :loading="savingNote" :disabled="savingNote"
              ></v-autocomplete>
            </td>
            <td>
              <v-text-field v-model="form.note" label="Note" :rules="[v => !!v || 'This field is required.']" solo-inverted dense :loading="savingNote" :disabled="savingNote"></v-text-field>
            </td>
            <td class="pb-5">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" @click="submitNote" class="success white--text" icon small :loading="savingNote" :disabled="savingNote"><v-icon>mdi-arrow-right</v-icon></v-btn>
                </template>
                <span>Submit Note</span>
              </v-tooltip>
            </td>
          </tr>
          <!--          </v-form>-->
          <tr v-for="note in sample.sample_notes" :key="note.uuid">
            <td>{{ note.note_type.name }}</td>
            <td>{{ note.note }}</td>
            <td>
              <SampleEditNote :note="note"></SampleEditNote>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-form>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "SampleNotes",
  components: {
    SampleEditNote: () => import("@/views/orders/components/SampleEditNote")
  },
  data: () => ({
    show: false,
    savingNote: false,
    savingFlags: false,
    applyFlags: [],
    form: {
      uuid: null,
      note: null,
      sample_note_type_uuid: null,
      sample_uuid: null,
    }
  }),
  props:{
    sample: {
      required: true,
    }
  },
  computed: {
    flagTypes(){
      let flags = this.$store.$db().model('sampleFlagTypes').all();
      let filtered = this.$store.state.filtered_flags || this.$store.state.manifest_filtered_flags || [];
      if (filtered.length > 0) {
        return flags.filter(flag => !filtered.includes(flag.uuid));
      }
      return flags;
    }
  },
  methods: {
    async submitNote(){
      if(!this.$refs.form.validate()) return;
      try{
        this.savingNote = true;
        this.form.sample_uuid = this.sample.uuid;
        this.form.created_by = this.$store.getters.id;
        this.form.updated_by = this.$store.getters.id;
        await this.$store.$db().model('sampleNotes').api().save(this.form);
        this.$refs.form.reset();
      }catch(e){
        this.$store.dispatch("showError", "Failed to submit note")
      }finally{
        this.savingNote = false;
      }
    },
    async submitFlags(){
      this.savingFlags = true;
      let flags = this.applyFlags.filter(flag => !this.sample.sample_flags.some(sampleFlag => sampleFlag.sample_flag_type_uuid === flag));
      flags = flags.map((flag) => {
        return {
          uuid: null,
          sample_flag_type_uuid: flag,
          sample_uuid: this.sample.uuid,
        }
      });
      try{
        this.savingFlags = true;
        await this.$store.$db().model('sampleFlags').api().save({
          collection: flags
        });
      }catch(e){
        this.$store.dispatch("showError", "Failed to save flags");
      }finally{
        this.savingFlags = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
